<template>
    <div class="flex w-full h-screen overflow-hidden bg-slate-100">
        <div class="flex-1 w-full overflow-hidden">
            <Topbar />
            <div class="mt-[64px] flex h-[calc(100vh-64px)] flex-col overflow-hidden p-4 md:p-5 lg:p-6">
                <RouterLink to="/store" class="mb-3 inline-flex w-fit items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900">
                    <i class="pi pi-arrow-left" />
                    Назад
                </RouterLink>

                <div class="mb-4 flex shrink-0 items-start justify-between gap-3">
                    <div>
                        <h2 class="text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">Списанные товары</h2>
                        <p class="mt-1 text-sm text-slate-500 md:text-base">История списаний с указанием причины и фотофиксации</p>
                    </div>
                </div>
        
                <Toast />
                <div class="min-h-0 flex-1 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:p-6">
          
                    <DataTable
                        :value="writeOffProducts" responsiveLayout="scroll"
                        removableSort showGridlines stripedRows paginator size="small" headerClass="!text-center"
                        :rows="10" :rowsPerPageOptions="[5, 10]"
                        :filters="filters" filterDisplay="menu" :globalFilterFields="['name', 'phone', 'email']"
                        class="reference-table h-full"
                        scrollable scrollHeight="flex"
                    >   
                        <template #header>
                          <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                            <div class="flex flex-wrap gap-2 items-center">
                                <IconField>
                                    <InputIcon> <i class="pi pi-search" /> </InputIcon>
                                    <InputText v-model="filters['global'].value" placeholder="Поиск по списаниям..." />
                                </IconField>
                                <Button type="button" icon="pi pi-filter-slash" label="Очистить" variant="outlined" severity="secondary" @click="clearFilter()" />
                            </div>
                          </div>
                        </template>
                        <Column field="name"           header="Название" sortable/>
                        <Column field="counterparty"   header="Контрагент" />
                        <Column field="barcode"        header="Штрихкод" />
                        <Column field="date"           header="Дата списания" />
                        <Column field="classification" header="Класс" />
                        <Column field="category"       header="Категория" />
                        <Column field="quantity"       header="Кол-во" />
                        <Column field="image"          header="Фото" >
                            <template #body="{ data }">
                              <img :src="data.image" :alt="data.image" class="shadow-lg cursor-pointer" width="64" @click="openImage(data)" />
                            </template>
                        </Column>
                        <Column field="reason"         header="Причина списания" />
                    </DataTable>

                    <Dialog v-model:visible="imageDialog" :style="{ width: '500px' }" :header="selectedProduct.name" :modal="true" v-if="selectedProduct">
                        <div class="flex justify-center items-center gap-4">
                            <div class="w-full">
                                <img :src="selectedProduct.image" :alt="selectedProduct.name" class="w-full h-full object-cover"/>
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '../lib/axios'
import * as XLSX from 'xlsx'
import { useToast } from 'primevue/usetoast'
import Toast from 'primevue/toast';
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'

const toast = useToast()
const writeOffProducts = ref([])
const imageDialog = ref(false)
const selectedProduct = ref()

// filters
const filters = ref({
    'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
})

const initFilters = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    }
}
initFilters()

const clearFilter = () => {
    initFilters()
}

const openImage = (product) => {
  if (product) {
    imageDialog.value = true
    selectedProduct.value = product
  }
}

const fetchWriteOffProducts = async () => {
    const { data } = await axios.get('/api/write-off-products')
    writeOffProducts.value = data
}

onMounted(() => {
    fetchWriteOffProducts()
})
</script>

<style scoped>
:deep(.reference-table),
:deep(.reference-table .p-datatable-table-container) {
  height: 100%;
}

:deep(.reference-table .p-datatable-header) {
  border: 0;
  border-bottom: 1px solid rgb(226 232 240);
  background: rgb(255 255 255);
  padding: 0 0 1rem 0;
}

:deep(.reference-table .p-datatable-thead > tr > th) {
  background: rgb(248 250 252);
  color: rgb(71 85 105);
  font-weight: 600;
  border-color: rgb(226 232 240);
  padding: 0.875rem 1rem;
}

:deep(.reference-table .p-datatable-tbody > tr > td) {
  border-color: rgb(241 245 249);
  color: rgb(51 65 85);
  padding: 0.875rem 1rem;
}

:deep(.reference-table .p-datatable-tbody > tr:hover > td) {
  background: rgba(248, 250, 252, 0.95);
}

:deep(.reference-table .p-paginator) {
  border-top: 1px solid rgb(226 232 240);
  background: rgb(255 255 255);
  padding: 0.75rem 1rem;
}

:deep(.reference-table .p-paginator-page.p-paginator-page-selected) {
  background: rgb(16 185 129);
  color: rgb(255 255 255);
}
</style>
